export default __webpack_public_path__ + "static/brand-static-sprite-84823a5af916e7cdd6e5e2a907f1e6be.svg";